const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  language: state => state.app.language,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  subNoListObj: state => state.label.subNoListObj,
  binLevelObj: state => state.label.binLevelObj,
  machineHandNoObj: state => state.label.machineHandNoObj,
  labelPrintCountObj: state => state.label.labelPrintCountObj,
  queryMachineHandNoUsedObj: state => state.label.queryMachineHandNoUsedObj,
};

export default getters;
